import React from "react";
import { withRouter } from "react-router-dom";
import DashboardLayout from "../../components/universal/dashboard-layout";
import DashboardLeftNavigation from "../../components/universal/dashboard-left-navigation";
import DashboardUpperNavigation from "../../components/universal/dashboard-upper-navigation";
import DashboardSingleClientIndex from "../../components/dashboard/single-client";

const Index = (props) => {
  return (
    <DashboardLayout
      DashboardLeftNavigation={() => <DashboardLeftNavigation />}
      DashboardUpperNavigation={() => <DashboardUpperNavigation />}
      DashboardContent={() => (
        <DashboardSingleClientIndex id={props.match.params.id} />
      )}
    />
  );
};

export default withRouter(Index);
